module.exports = __webpack_public_path__ + "img/step-2.d79357f6.svg";